/* eslint-disable camelcase */
export interface DataDogLoggerShape {
  actionName: string;
  url: string;
  loadDuration: number;
  errorText?: string;
  estimated?: boolean;
}

export type PusherResponse<Response = unknown> =
  | {
      pusher_error: string;
    }
  | Response;
export interface CompressedPusherResponse {
  is_compressed: true;
  compressed_payload: string;
}

export interface PusherError {
  pusher_error: string;
}

export const isPusherError = (a: any): a is PusherError => !!a?.pusher_error;

export const isCompressedPusherResponse = (response: unknown): response is CompressedPusherResponse => {
  const check = response as CompressedPusherResponse;
  return check && check.is_compressed;
};
